/**
 * Role-based dashboard path — used by DashboardRedirect and other post-auth navigation.
 */

export const getDashboardPathForRole = (userRole) => {
	switch (userRole) {
		case 'System Admin':
			return '/dashboard/system';
		case 'Company Admin':
			return '/dashboard/company';
		case 'Employee':
			return '/dashboard/employee';
		default:
			return '/unauthorized';
	}
};
